module.exports = __webpack_public_path__ + "static/media/template2.501012d9.png";